/* template */
<template><div :class="(noIcon && 'noicon')" class="transfer-info"><div class="transfer-info-left"><mpx-image src="https://ut-static.udache.com/webx/sfc/6bN5XS8kMoyrAngJ01pVE.png" class="transfer-info-left-icon" v-if="(!noIcon)"/><div :class="(noIcon && 'noicon')" class="transfer-info-left-title">{{
        transferTitle
      }}</div><div class="transfer-info-left-time" v-if="(stopTime)">停留{{ stopTime }}</div></div><div class="transfer-info-right" v-if="(transferDiff && navTime)"><div :class="(noIcon && 'noicon')" class="transfer-info-right-consuming">打车预计{{ navTime }}分钟</div><mpx-view @tap="navigate" class="transfer-info-right-navigation" v-if="(isPassenger)"><mpx-image :src="(navigateIcon)" class="transfer-info-right-navigation-icon"/><span :class="(noIcon && 'noicon')" class="navigation-text">导航</span></mpx-view></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m794aa58f"}'>
  .transfer-info
    display flex
    justify-content space-between
    align-items center
    padding 7px 20px
    background-color #fff
    &.noicon
      padding 12px 0
    &-left
      display flex
      align-items center
      &-icon
        height 11px
        width 11px
        margin-right 3px
      &-title
        font-family PingFangSC-Medium
        font-size 12px
        font-weight 500
        line-height 18px
        color #222
        margin-right 8px
        &.noicon
          font-size 18px
      &-time
        font-size 12px
        font-weight 400
        line-height 14px
        color #666
    &-right
      display flex
      align-items center
      font-size 12px
      font-weight 400
      line-height 14px
      color #338FFF
      &-navigation
        display flex
        align-items center
        position relative
        margin-left 16.5px
        &::after
          content ''
          position absolute
          height 24px
          width 1px
          left -8px
          top 50%
          transform translateY(-50%) scale(0.5)
          background rgba(102, 102, 102, 0.502)
        &-icon
          height 12px
          width 12px
          margin-right 2px
        .navigation-text
          &.noicon
            color #333
      &-consuming
        position relative
        &.noicon
          color #666
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m794aa58f"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./transfer-info-tip.mpx.js?isComponent&outputPath=components%2Ftransfer-info-tip794aa58f%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./transfer-info-tip.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftransfer-info-tip794aa58f%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m794aa58f"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/transfer-info-tip794aa58f/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
